module.exports = __webpack_public_path__ + "img/mono_27.7cd706ce.png";